export function getParentControllerForIdentifier(identifier) {
  return this.application.controllers.find((controller) => {
    return (
      controller.context.identifier === identifier &&
      controller.element.contains(this.element)
    );
  });
}
